import React from 'react';

import { useIntl } from 'react-intl-next';

import { type SearchResultBranchPartial } from '@atlassian/dynamic-cards-search-client';

import { LastModified } from '../../../../../../../common/ui/last-modified';
import { RestrictedIcon } from '../../../../../../../common/ui/restricted-icon';
import { SearchMetadata } from '../../../../../../../common/ui/search-metadata';
import { SearchResult } from '../../../../../../../common/ui/search-result';
import {
	getIntegrationKey,
	isNonPublic,
} from '../../../../../../../common/utils/search-result-utils';
import { useBootstrap, usePrimaryProduct } from '../../../../../../../controllers/store';

import { messages } from './messages';
interface BranchSearchResultProps {
	icon: React.ReactNode;
	partial: SearchResultBranchPartial;
	position?: number;
}

export const BranchSearchResult = ({
	partial,
	position,
	icon,
}: BranchSearchResultProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const [primaryProduct] = usePrimaryProduct();
	const [{ cloudId }] = useBootstrap();

	const { lastModifiedDate, url, permissionLevel, entity } = partial;
	const { name: branchName, container } = entity || {};
	const label = formatMessage(messages.resultLabel);
	const integrationKey = getIntegrationKey(partial.integrationId);

	const lastModifiedComponent = lastModifiedDate ? (
		<LastModified lastModified={lastModifiedDate} />
	) : null;

	const padlockIcon = isNonPublic(permissionLevel) ? (
		<RestrictedIcon permissionLevel={permissionLevel} />
	) : null;

	return (
		<SearchResult
			id={partial.id}
			icon={icon}
			description={''}
			headerMetadata={
				<SearchMetadata
					product={integrationKey}
					productSelected={true}
					parts={[
						label,
						['repository-name', container?.name ?? null],
						['padlock', padlockIcon],
						['last-modified', lastModifiedComponent],
					]}
				/>
			}
			title={branchName}
			url={url}
			isThirdParty
			cloudId={cloudId}
			primaryProduct={primaryProduct}
			position={position}
			partial={partial}
		/>
	);
};
